import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  methods: Yup.array().min(1, 'empty'),
  onlyCheapestShipping: Yup.boolean().default(false).required(),
});
